<template>
    <div class="card chamber-search"  :id="'chamber-search-'+chamber_search.id">
        <div class="card-header">
            <h3 class="card-title py-1 my-0">
                {{chamber_search.keyword}}
            </h3>
            <div class="card-tools">
                <span v-if="monitoring" class="blink d-inline-block float-left">
                    {{translate('messages.monitoring')}} 
                </span>
                <button class="btn btn-tool no-shadow" @click="toggleMonitor" v-tooltip:bottom="translate('messages.activate_deactivate_monitoring')" data-toggle="tooltip">
                    <radar :monitoring="monitoring"/>
                </button>
            </div>
        </div>
        <div class="card-toolbar card-header p-1 text-right">
            <h5 class="float-left m-0 pl-2">
                {{translate('messages.'+chamber_search.type+'s')}} 
                <small v-if="hits.total" >({{hits.total ? hits.from : 0}} - {{(hits.total < (hits.current_page*hits.per_page)) ? hits.total : (hits.current_page*hits.per_page)}} {{translate('messages.from')}} {{hits.total}})</small>
            </h5>
            <button class="btn btn-default btn-sm" :class="$root.app_config.dark_mode ? 'white' : ''" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand fa-lg" style="vertical-align: middle;"></i></button>
        </div>
        <!-- /.card-header -->
        <div class="card-body card-comments" :id="'chamber-search-'+chamber_search.id+'-hits'">
            <div v-if="hits.hasOwnProperty('data')">
                <div v-for="(hit) in hits.data.hits" :key="'hit-'+hit._id" class="card-comment">
                    <chronicle-hit v-if="chamber_search.type == 'chronicle'" :hit="hit" />
                    <gazette-hit v-if="chamber_search.type == 'gazette'" :hit="hit" />
                    <initiative-hit v-if="chamber_search.type == 'initiative'" :hit="hit" />
                    <dictamination-hit v-if="chamber_search.type == 'dictamination'" :hit="hit" />
                    <vote-hit v-if="chamber_search.type == 'vote'" :hit="hit" />
                    <day-order-hit v-if="chamber_search.type == 'day_order'" :hit="hit" />
                </div>
            </div>
            <div v-if="!loading && !hits.hasOwnProperty('data')" class="alert alert-warning">
                <h5><i class="icon fas fa-exclamation-triangle"></i> {{translate('messages.empty_results')}}</h5>
                {{translate('messages.empty_results_message')}}.
            </div>
        </div>
        <div class="card-footer">
            <div v-if="hits.total" class="float-left">
                <label :for="'page-selector-'+chamber_search.id">{{translate('messages.go_to_page')}}:</label> 
                <select class="form-control-border" :id="'page-selector-'+chamber_search.id" @change="goToPage($event)">
                    <option v-for="n in Math.ceil(total/10)" :key="'chamber-search-'+chamber_search.id+'-ps-'+n" :value="n">{{n}}</option>
                </select>
            </div>
            <pagination :limit="3" class="pagination-sm m-0 float-right" :data="hits" @pagination-change-page="loadHits"></pagination>
        </div>
        <div v-if="loading" class="overlay dark">
            <i class="fas fa-sync fa-spin fa-2x"></i>
        </div>
    </div>
</template>

<script>
import ChronicleHit from '../mxChamber/hits/ChronicleHit.vue';
import GazetteHit from '../mxChamber/hits/GazetteHit.vue';
import InitiativeHit from '../mxChamber/hits/InitiativeHit.vue';
import DictaminationHit from '../mxChamber/hits/DictaminationHit.vue';
import VoteHit from '../mxChamber/hits/VoteHit.vue';
import DayOrderHit from '../mxChamber/hits/DayOrderHit.vue';
export default {
    components: {
        ChronicleHit,
        GazetteHit,
        InitiativeHit,
        DictaminationHit,
        VoteHit,
        DayOrderHit
    },
    props: ['chamber_search'],
    data () {
        return {
            hits : {},
            loading : true,
            timer: null,
            monitoring: false,
            page: 1,
            total: 0
        }
    },
    methods: {
        loadHits(page = 1){
            this.loading = true;
            this.page = isNaN(page) ? 1 : page;
            axios.get('/api/chamberSearch/hits/'+this.chamber_search.id+'?page=' + this.page).then(({ data }) => {
                this.hits = data.data;
                this.total = this.hits.total;
                this.loading = false;
                $('#chamber-search-'+this.chamber_search.id+'-hits').animate({
                    scrollTop: 0
                }, 'slow');
            });
        },
        toggleMonitor(){
            this.monitoring = !this.monitoring;
            if(this.monitoring){
                this.timer = setInterval(function(){
                    this.loadHits();
                }.bind(this), 60 * 1000);
            }else{
                clearInterval(this.timer);
            }
        },
        goToPage(event){
            this.loadHits(event.target.value);
        }
    },
    mounted() {

    },
    created() {
        this.loadHits();
    },
    beforeDestroy() {
        if(this.timer) clearInterval(this.timer);
    },
    watch: {
        hits(){
            this.$forceUpdate();
        }
    }
}
</script>